import PropTypes from 'prop-types';
import { values } from 'ramda';

export const MENU = {
  IDENTITY: 'identity',
  ACTIVITY: 'activity',
  STATISTICS: 'statistics',
};

export const MenuType = PropTypes.oneOf(values(MENU));
